var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterPanelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00BDB4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,4.5H9.3C9,3.5,8.1,2.8,7,2.8S5,3.5,4.6,4.5H2.8C2.4,4.5,2,4.9,2,5.3s0.4,0.8,0.8,0.8h1.9 C5,7.1,5.9,7.8,7,7.8s2-0.7,2.3-1.7h11.9c0.4,0,0.8-0.4,0.8-0.8S21.6,4.5,21.2,4.5z M7,6.2c-0.5,0-0.9-0.4-0.9-0.9S6.5,4.4,7,4.4 s0.9,0.4,0.9,0.9S7.5,6.2,7,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,11.2h-1.9c-0.3-1-1.2-1.7-2.3-1.7s-2,0.7-2.3,1.7H2.8C2.4,11.2,2,11.6,2,12c0,0.4,0.4,0.8,0.8,0.8h11.9 c0.3,1,1.2,1.7,2.3,1.7s2-0.7,2.3-1.7h1.9c0.4,0,0.8-0.4,0.8-0.8C22,11.6,21.6,11.2,21.2,11.2z M17,12.9c-0.5,0-0.9-0.4-0.9-0.9 c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9C17.9,12.5,17.5,12.9,17,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,17.9h-8.6c-0.3-1-1.2-1.7-2.3-1.7s-2,0.7-2.3,1.7H2.8c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8H8 c0.3,1,1.2,1.7,2.3,1.7s2-0.7,2.3-1.7h8.6c0.4,0,0.8-0.4,0.8-0.8S21.6,17.9,21.2,17.9z M10.3,19.6c-0.5,0-0.9-0.4-0.9-0.9 c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9C11.2,19.2,10.8,19.6,10.3,19.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPanelIcon);
export default __webpack_public_path__ + "static/media/filter-panel-icon.194d4585e6afe92322025118edfddf0d.svg";
export { ForwardRef as ReactComponent };